module.exports = __webpack_public_path__ + "img/profile-background.92677ac3.svg";